/** Colours sent to the box and to other clients: wire values, never swap them for palette tokens. */
export const SHARED_COLORS = {
  headsetBlue: '#3C91E6',
  headsetPink: '#F29CA3',
  headsetYellow: '#D9D10C',
  headsetPurple: '#921ED9',
  headsetGreen: '#3AB530',
  headsetNone: '#BEBEBE',
  maskDefault: '#0377fc',
  maskNew: '#41403A',
  drawHighlight: '#FDD354',
  drawInk: '#000000',
} as const;
